import axios from "axios"
import get from "lodash/get"
import URITemplate from "urijs/src/URITemplate"
import {
  SUBMIT_CONTRACT_RENEWAL_FAILED,
  SUBMIT_CONTRACT_RENEWAL_FULFILLED,
  SUBMIT_CONTRACT_RENEWAL_PENDING,
} from "constants-lib/actionTypes"
import { getTokenAction } from "actions-lib/getToken"
import { urls } from "utils-lib/builds"

export const pendingAC = () => ({
  type: SUBMIT_CONTRACT_RENEWAL_PENDING,
})

export const failedAC = () => ({
  type: SUBMIT_CONTRACT_RENEWAL_FAILED,
})

export const fulfilledAC = (data) => ({
  type: SUBMIT_CONTRACT_RENEWAL_FULFILLED,
  payload: data,
})

export const submitContractRenewal =
  ({ customerId, payload }) =>
  (dispatch, getState) => {
    const api = `CONTRACT_RENEWAL_SUBMIT`
    const template = URITemplate(urls.url[api])
    const state = getState()
    const url = template.expand({
      userId: get(state, `userAccount.userDetails.userId`, ``),
      customerId,
      lang: get(state, `siteLanguage.language`, ``),
    })

    const config = {
      method: `POST`,
      headers: {},
      data: payload,
    }

    return getTokenAction(dispatch, getState).then(async (res) => {
      config.headers.oktaToken = res.accessToken
      config.headers.apiKey = get(urls, `apiKey.USER[${api}]`, ``)
      return submitContractRenewalHelper(url, config, dispatch)
    })
  }

export const submitContractRenewalHelper = (url, config, dispatch) => {
  dispatch(pendingAC())

  return axios(url, config)
    .then((response) => {
      const data = get(response, "data", {})
      dispatch(fulfilledAC(data))
      return data
    })
    .catch((error) => {
      dispatch(failedAC())
      return error.response.status
    })
}
